import {
  mediaSmallOrTiny,
  mediaConfinedOnly,
  mediaWide,
} from '@xingternal/layout-tokens';

import { BREAKPOINTS } from './breakpoints';

export const listeners = [];

const breakpointRanges = {
  [BREAKPOINTS.handheld]: mediaSmallOrTiny,
  [BREAKPOINTS.tablet]: mediaConfinedOnly,
  [BREAKPOINTS.desktop]: mediaWide,
};

const breakpoints = Object.entries(breakpointRanges).map(([name, query]) => ({
  name,
  query,
}));

let matchedMedia = null;

/** @private */
export function init(matchMedia) {
  if (typeof matchMedia === 'function') {
    const matchedBreakpoint = breakpoints.find(
      ({ query }) => matchMedia(query).matches
    );
    matchedMedia = matchedBreakpoint
      ? matchedBreakpoint.name
      : BREAKPOINTS.handheld;
  } else {
    matchedMedia = BREAKPOINTS.handheld;
  }

  if (typeof matchMedia === 'function') {
    breakpoints.forEach(({ name, query }) => {
      matchMedia(query).addListener(({ matches }) => {
        if (matches) {
          matchedMedia = name;
          listeners.forEach((listener) => listener(name));
        }
      });
    });
  }
}

init(typeof window !== 'undefined' ? window.matchMedia : null);

export default function getMatchedMedia() {
  return matchedMedia;
}
